import { render, staticRenderFns } from "./datosDireccion.vue?vue&type=template&id=24f94cd9&"
import script from "./datosDireccion.vue?vue&type=script&lang=js&"
export * from "./datosDireccion.vue?vue&type=script&lang=js&"
import style0 from "./datosDireccion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports